<div class="modal-body">
  <div class="col-sm-12">
    <h4>{{userAction}} User</h4>
    <hr>
    <div *ngIf="userAction=='Edit'">
      <label>User name</label>
      <input type="text" [(ngModel)]="user.name" placeholder="Name" class="form-control my-4" />
      <button class="btn btn-danger mx-1" (click)="close()">Cancel</button>
      <button class="btn btn-info mx-1" (click)="update()">update</button>
    </div>
    <div *ngIf="userAction=='Add'">
      <form action="" class="mt-5 text-center" #user="ngForm"  novalidate (ngSubmit)="addUser(user)">
        <div class="form-group mb-4">
          <input ngModel #name="ngModel" required maxlength="50" type="text" class="form-control" name="name" placeholder="Name">
          <p class="text-danger" *ngIf="!name.valid && user.submitted">
            <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="name.errors.required">Name is required!</span>
          </p>
        </div>
        <div class="form-group mb-4">
          <input ngModel #email="ngModel" required  type="text" class="form-control" name="email" placeholder="Email" pattern="^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$">
          <p class="text-danger" *ngIf="!email.valid && user.submitted">
            <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="email.errors.required">Email is required!</span>
            <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="email.errors.pattern">Please enter a valid email address.</span>
          </p>
        </div>
        <div class="form-group mb-4">
            <input ngModel #password="ngModel" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*" required minlength="8" maxlength="50" type="text" class="form-control" name="password" placeholder="Enter password">
            <p class="text-danger" *ngIf="!password.valid && user.submitted">
              <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="password.errors.required">Password is required!</span>
              <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="password.errors.pattern">Minimum of 8 characters, 1 uppercase letter, 1 lowercase letter, and 1 number.</span>
            </p>
        </div>
        <select class="form-control" [(ngModel)]="roleId" name="roleId">
          <option [value]="0">Select Type</option>
          <option [value]="3">User</option>
          <option [value]="2">Admin</option>
        </select>
        <p class="text-danger" *ngIf="roleError">
          <span class="d-block text-left mt-1 ml-1 small text-danger">Role is required!</span>
        </p>
        <br>
        <div class="form-group mb-5">
          <input type="submit" class="btn btn-info" value="Add User">
          <button class="btn btn-danger mx-1" (click)="close()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
